module.exports = __webpack_public_path__ + "static/img/craigchanti_circle150.db4ccfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/craigchanti_circle150.png
// module id = sfLy
// module chunks = 0